module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("Пункты меню (перенести в меню)")]), _vm._v(" "), ((_vm.cmsMenuItems != null)) ? _c('div', [_c('entity-manager', {
    staticStyle: {
      "padding-top": "20px"
    },
    attrs: {
      "data": _vm.cmsMenuItems,
      "options": _vm.cmsMenuItemsEntityManagerOptions
    },
    scopedSlots: _vm._u([{
      key: "dataItemFieldTableView",
      fn: function(viewProps) {
        return [(viewProps.column.field == 'content') ? _c('span', [((viewProps.dataRow.val[viewProps.column.field] != -1) && (viewProps.dataRow.val[viewProps.column.field] != '') && (viewProps.dataRow.val[viewProps.column.field] != null)) ? _c('span', [_vm._v("\n            Есть\n          ")]) : _c('span', [_vm._v("\n            Нет\n          ")])]) : _c('span', [_vm._v("\n          " + _vm._s(viewProps.dataRow.val[viewProps.column.field]) + "\n        ")])]
      }
    }, {
      key: "dataItemFieldEditView",
      fn: function(viewProps) {
        return [((viewProps.fieldKey == 'name') || (viewProps.fieldKey == 'urlToPage') || (viewProps.fieldKey == 'weight')) ? _c('span', [_c('Input', {
          staticStyle: {
            "width": "100%"
          },
          model: {
            value: (viewProps.editingDataRow.val[viewProps.fieldKey]),
            callback: function($$v) {
              var $$exp = viewProps.editingDataRow.val,
                $$idx = viewProps.fieldKey;
              if (!Array.isArray($$exp)) {
                viewProps.editingDataRow.val[viewProps.fieldKey] = $$v
              } else {
                $$exp.splice($$idx, 1, $$v)
              }
            },
            expression: "viewProps.editingDataRow.val[viewProps.fieldKey]"
          }
        })], 1) : ((viewProps.fieldKey == 'belongsToMenu')) ? _c('span', [_c('select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (viewProps.editingDataRow.val[viewProps.fieldKey]),
            expression: "viewProps.editingDataRow.val[viewProps.fieldKey]"
          }],
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "filterable": "",
            "placeholder": "Выберите меню"
          },
          on: {
            "change": function($event) {
              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                return o.selected
              }).map(function(o) {
                var val = "_value" in o ? o._value : o.value;
                return val
              });
              var $$exp = viewProps.editingDataRow.val,
                $$idx = viewProps.fieldKey;
              if (!Array.isArray($$exp)) {
                viewProps.editingDataRow.val[viewProps.fieldKey] = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
              } else {
                $$exp.splice($$idx, 1, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
              }
            }
          }
        }, [_c('option', {
          attrs: {
            "value": "-1"
          }
        }, [_vm._v("Нет")]), _vm._v(" "), _vm._l((_vm.cmsMenus), function(item) {
          return _c('option', {
            key: item.val.id,
            domProps: {
              "value": item.val.id
            }
          }, [_vm._v(_vm._s(item.val.name))])
        })], 2)]) : _c('div', {
          staticStyle: {
            "width": "100%",
            "height": "26px"
          }
        }, [_vm._v("\n          " + _vm._s(viewProps.editingDataRow.val[viewProps.fieldKey]) + "\n        ")])]
      }
    }])
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f3b3cbc","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CMSX/MenusItems.vue
// module id = 373
// module chunks = 0